import React from 'react'
import Avatar from '@material-ui/core/Avatar'
import { makeStyles } from '@material-ui/core/styles'
import { useAuth } from 'lib/auth'
import { getInitials } from 'lib/text-display'
import * as maybe from 'lib/maybe'

const PROFILE_AVATAR_SIZE = 72
const PROFILE_AVATAR_FONT_SIZE = 20

export const getCoachAvatarFontSize = avatarSize =>
  `${(PROFILE_AVATAR_FONT_SIZE / PROFILE_AVATAR_SIZE) * avatarSize}px`

const getSizeInPixels = value => {
  if (value == null) {
    return null
  }

  if (typeof value === 'number') {
    return value
  }

  const match = String(value).match(/^([\d.]+)(px|rem)?$/)
  if (!match) {
    return null
  }

  const amount = Number(match[1])
  return match[2] === 'rem' ? amount * 16 : amount
}

const useStyles = makeStyles(() => ({
  avatar: {
    color: '#00205B',
    backgroundColor: '#E8F1FF',
    fontWeight: 500,
    textTransform: 'uppercase',
  },
}))

export const getCoachAvatarContent = user =>
  maybe
    .of(user)
    .map(({ name, email }) => name || email)
    .map(displayName => {
      const initials = getInitials(displayName)
      return initials || displayName.charAt(0).toUpperCase()
    })
    .withDefault('U')

const CoachUserAvatar = ({ className, style, size, ...rest }) => {
  const classes = useStyles()
  const { user } = useAuth()
  const avatarSize =
    size ?? getSizeInPixels(style?.width) ?? getSizeInPixels(style?.height)
  const mergedStyle = {
    ...style,
    ...(avatarSize && style?.fontSize == null
      ? { fontSize: getCoachAvatarFontSize(avatarSize) }
      : {}),
  }

  return (
    <Avatar
      className={[classes.avatar, className].filter(Boolean).join(' ')}
      style={mergedStyle}
      src={user?.coach?.coachProfile?.profilePhoto}
      {...rest}
    >
      {getCoachAvatarContent(user)}
    </Avatar>
  )
}

export default CoachUserAvatar
